import { render, staticRenderFns } from "./PsPatientBtnNewDisease.vue?vue&type=template&id=0511ec48&scoped=true&"
import script from "./PsPatientBtnNewDisease.vue?vue&type=script&lang=js&"
export * from "./PsPatientBtnNewDisease.vue?vue&type=script&lang=js&"
import style0 from "./PsPatientBtnNewDisease.vue?vue&type=style&index=0&id=0511ec48&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0511ec48",
  null
  
)

export default component.exports